import instance from './instance';
import * as R from 'ramda';

export default (params) =>
  instance()
    .post('/coupons', params)
    .then(({ data: { result } }) => result)
    .catch((error) =>
      R.either(
        R.path(['response', 'data', 'errors[0]']),
        R.pathOr("Can't create coupon", ['response', 'data', 'errors'])
      )(error)
    );
